/** 控制台试用页（/console/playground）。 */
const messages = {
  'page.title': '控制台试用',
  'page.description':
    '在控制台直接提交视频任务，参数与 /v1/videos/generations 完全一致，用于验证效果与费用。',
  'page.modelsFailed': '模型列表加载失败',

  'noModel.alt': '示意画面：晨雾中的山间小镇',
  'noModel.note': '示意画面，由程序生成，并非 Seedance 输出',
  'noModel.title': '账号还没有可用的模型',
  'noModel.body': '联系运营为账号开通模型授权与额度后即可试用。',
  'noModel.email': '邮箱：{email}',
  'noModel.wechat': '微信：{id}',
  'noModel.models': '查看模型与价格',

  'opt.seed.label': '随机种子',
  'opt.seed.description': '相同种子与参数可得到相近结果；留空为随机',
  'opt.camera_fixed.label': '固定镜头',
  'opt.camera_fixed.description': '尽量保持机位不动',
  'opt.watermark.label': '添加水印',
  'opt.watermark.description': '在视频角落添加 AI 生成标识',
  'opt.generate_audio.label': '生成音频',
  'opt.generate_audio.description': '同时生成与画面匹配的声音',
  'opt.return_last_frame.label': '返回尾帧',
  'opt.return_last_frame.description': '额外返回最后一帧图片，便于接续下一段',
  'opt.omni_reference_task_type.label': '参考任务类型',
  'opt.omni_reference_task_type.description':
    '使用参考视频做编辑或延长时建议明确指定，参数不合要求会在提交时直接报错，不会白等',
  'optValue.auto': '自动判断',
  'optValue.reference': '参考生成',
  'optValue.edit': '视频编辑',
  'optValue.extend': '视频延长',
  'opt.default': '默认',
  'opt.seedPlaceholder': '随机',

  'picker.asset': '素材',
  'picker.title': '选择{target}',
  'picker.description': '只列出状态为“可用”的{kind, select, image {图片} video {视频} other {音频}}素材。',
  'picker.descriptionMax':
    '只列出状态为“可用”的{kind, select, image {图片} video {视频} other {音频}}素材，最多 {n} 个。',
  'picker.max': '最多选择 {n} 个',
  'picker.empty': '没有可用的素材。先到素材库上传，处理完成后即可在这里选择。',
  'picker.toLibrary': '去素材库',
  'picker.cancel': '取消',
  'picker.confirm': '确定',
  'picker.confirmCount': '确定（{n}）',

  'slot.count': '（{n}/{max}）',
  'slot.remove': '移除 {name}',
  'slot.choose': '选择{kind, select, image {图片} video {视频} other {音频}}',

  'err.promptMax': '提示词最多 {n} 个字符',
  'err.promptRequired': '文生视频需要填写提示词',
  'err.firstFrame': '请选择首帧图片',
  'err.lastFrame': '请选择尾帧图片',
  'err.reference': '至少选择一个参考素材',
  'err.audioNeedsVisual': '参考音频需要同时提供图片或视频',
  'err.videoTotal': '参考视频总时长不能超过 {max} 秒（当前 {current} 秒）',
  'err.audioTotal': '参考音频总时长不能超过 {max} 秒',
  'err.budget': '请输入大于 0 的金额，最多 6 位小数',
  'err.seed': '种子必须是整数',
  'err.fix': '请先修正标出的参数',

  'toast.submitted': '任务已提交',
  'toast.submittedDescription': '已冻结 {amount} {currency}，结束后按用量结算。',

  'dur.seconds': '{n} 秒',
  'dur.auto': '自动',

  'form.params': '参数',
  'form.model': '模型',
  'form.mode': '生成方式',
  'form.duration': '时长',
  'form.resolution': '分辨率',
  'form.ratio': '比例',
  'form.inputs': '输入素材',
  'form.inputsDescription': '从素材库选择，同一素材可在多个任务中重复使用。',
  'form.advanced': '高级选项',
  'form.budget': '单任务预算上限（可选）',
  'form.budgetPlaceholder': '不限',
  'form.budgetDescription': '冻结上界超过它时直接拒绝，不会创建任务。',

  'prompt.title': '提示词',
  'prompt.labelOptional': '提示词（可选）',
  'prompt.placeholder': '描述画面、主体动作与镜头运动，例如：镜头缓缓推进，晨雾中的山间小镇，暖色调',
  'prompt.placeholderOptional':
    '描述画面、主体动作与镜头运动，例如：镜头缓缓推进，晨雾中的山间小镇，暖色调（可选）',

  'cost.heading': '最高冻结',
  'cost.unavailable': '当前参数组合无法估算',
  'cost.note': '提交时按上界冻结，结束后按实际用量只结算一次，差额退回。',
  'cost.autoNote': '自动时长按上限 {max} 秒估算。',
  'cost.videoNote': '含视频输入（{duration}），按含视频单价计。',
  'cost.available': '可用额度',
  'cost.submit': '提交任务',
  'cost.submitNote': '真实生成、真实计费，与 API 调用一致。',
  'cost.insufficient': '可用额度不足以冻结。',
  'cost.insufficientBody': '降低时长或分辨率，或联系运营开通更多额度。',
  'cost.insufficientBodyWechat': '降低时长或分辨率，或联系运营开通更多额度（微信 {id}）。',
  'cost.paramError': '参数 {param} 有误',
  'cost.submitFailed': '提交失败',

  'equiv.title': '等价 API 请求',
  'equiv.description': '提交后跳转到任务详情，查看处理进度与生成结果。',
};

export default messages;
